import { Typography } from '@mui/material';
import PropTypes from 'prop-types';

/**
 * H1 heading component
 * Block-level heading component for main page titles
 */
const H1 = ({ children, ...props }) => {
  return (
    <Typography variant="h1" component="h1" {...props}>
      {children}
    </Typography>
  );
};

H1.propTypes = {
  children: PropTypes.node.isRequired,
};

export default H1;
